export default __webpack_public_path__ + "static/media/ilustrasi-virtual-account.82152ecd.png";